import React from 'react';
import { withRouter } from 'react-router';
import LoaderButton from '../../components/LoaderButton';
import Responsive from '../../components/Responsive';
import { checkTranslation, imageAddress, pathMaker, translate } from '../../utils/useful';
import { siteConfig } from '../../variables/config';
import { QRCode } from 'react-qrcode-logo';
// import ModernBg1 from '../../components/ModernBg1';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import * as actions from '../../stores/actionsList';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

class CHSuccess extends React.Component {

    state = {

    }

    componentDidMount() {

        this.props.showHeader(true, () => {

            if (this.props.setHeader) {
                this.props.setHeader({
                    'toolbar': null,
                    'showToolbar': false,
                    isPortal: true,
                    doNotshowNotification: true,
                    showSettings: false,
                    create: true,
                    'title': "{{lang}}Create hub | Successful",
                    topHeaderComponent: this.topHeaderComponent,
                    backAction: () => this.props.lastStage()
                })
            }

        })
    }

    topHeaderComponent = () => {


        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.props.initData.pendingLicense?.needsAction ? this.proceedToPayment: this.props.visitHub}
                    isLoading={this.state.isLoading}
                    title={this.props.initData.pendingLicense?.needsAction ? translate("Proceed to payment") : translate("View hub")}
                    // title={(this.props.initData.license?.planInfo?.priceType == 'free') ? translate("View hub") : translate("Proceed to payment")}

                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
                {/* <p></p> */}
            </div>

        )
    }


    nextStage = (cb) => {
        // this.setState({ isLoading: true, errors: {} })
        if (this.form) {
            let data = this.form.getForm()
            if (data) {
                this.props.setData(data, () => {
                    // this.props.postUserInfo((result, err) => {
                    // if (err) { this.setState({ errors: err }) }
                    // this.setState({ isLoading: false })
                    this.props.chooseNextPage()

                    // })
                })
            }
        }
    }


    info = (text) => {
        return (
            <div className='br-4 px-2 py-1' style={{ position: 'absolute', top: -24, backgroundColor: 'rgb(0, 0, 0, 0.8)' }}>
                <p className='font-size-12' style={{ color: '#fff', minInlineSize: 'max-content' }}>{text}</p>
            </div>
        )
    }


    handleCopy = (item) => {
        navigator.clipboard.writeText(item);
        this.props.actions.addNotif({ type: 'success', title: 'Successfuly Copied!', description: 'Information Successfuly Copied.' })
    }

    proceedToPayment=()=>{
        this.props.proceedToPayment()
    }


    render() {
        return (

            <div className=" w-100 h-100 position-relative window-content-radius overflow-hidden" style={{ position: 'relative', }}>
                <div className='w-100 h-100 position-absolute overflow-hidden '>
                    <div className='animated-bg' style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(88, 86, 214, 0.1) 0%, rgba(245, 228, 255, 0) 100%)' }}></div>

                    {/* <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(51, 231, 255, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}>
                    </div>

                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(50, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}>

                    </div> */}
                </div>
                <div className='d-flex flex-wrap w-100 h-100 position-relative scroll-no-scrollbar pb-5' style={{ padding: '0px 4%' }} >



                    <Responsive width={this.props.width} media={{ xs: "12", sm: '12', md: '6', lg: "6", xl: "6" }}>
                        <div className=' w-100 flexc flex-column ' >
                            <div className='w-100 flexcc'>
                                <div className="flexc flex-column mb-2 mt-4" style={{ maxWidth: 700, transition: 'all 0.5s', flex: '1 1 auto', borderRadius: 12 }}>

                                    {/* <div className="w-100 pt-5 flexc flex-column"> */}
                                    <div className="w-100 d-flex flex-column" style={{ maxWidth: 500, }}>
                                        {/* <img src={'/images/fireworks.svg'} width="80px" /> */}

                                        {/* <p onClick={() => this.props.visitHub()} className='mt-2 color-gray-2 text-semibold text-normal'>{this.props.language == 'fa' ? this.props.initData.username + '@' : '@' + this.props.initData.username}</p> */}

                                        {this.props.initData.pendingLicense?.needsAction && (
                                            <div className='flexce mb-4'>


                                                <div className='mt-0 w-100  br-8 p-3 pb-4' style={{ boxShadow: '0px 0px 20px #10101020', backgroundColor: '#fff' }}>

                                                    <div className='mb-3'>
                                                        <div className='flexc mb-1'>
                                                            <div className=' mrd-4 flexcc' >
                                                                <img src='/assets/icons/applets/general/diamond-award.png' height={24} alt='' />
                                                            </div>
                                                            <div>
                                                                <p className="text-small text-semibold" >{translate('Take next step')}</p>
                                                                <p className='text-bold text-semibig '>{translate("License payment")}</p>
                                                            </div>
                                                        </div>
                                                        <p className='text-semi text-small mb-1 pld-2'>{translate("Your license is not activated yet. Procceed to payment to activate your license.")}</p>

                                                        {/* <div className='flexc mb-1'>
                                                        <div className='br-20 px-2 py-1 text-small flexc' style={{ backgroundColor: 'rgb(251,240,207)', }}>
                                                            <div className='br-8 p-1 mrd-2 flexcc' style={{ color: 'rgb(1,47,158)' }}>
                                                                <img src='/assets/icons/applets/general/diamond-award.png' height={20} alt='' />
                                                            </div>
                                                            <div className='prd-4'>
                                                                <p className='font-size-14 main-c2 weight-600 ' style={{ color: 'rgb(210,140,10)' }}>{this.props.initData.license?.planInfo?.name ?? 'Starter'} plan</p>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    </div>

                                                    <ButtonAnimated
                                                        iconwidth='24px'
                                                        onClick={() => this.proceedToPayment()}
                                                        isLoading={false}
                                                        title={checkTranslation("Proceed to payment")}
                                                        // width={'100%'}
                                                        icon={'/assets/icons/angle-right-white2.svg'}
                                                        textColor={'#fff'}
                                                        invert={false}
                                                        bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                                    />

                                                </div>



                                            </div>
                                        )}


                                        <div className=' br-8 p-3  w-100' style={{ boxShadow: '0px 0px 20px #10101020', backgroundColor: '#fff' }}>

                                            <div className='flexc'>
                                                <div className=' mrd-4 flexcc' >
                                                    <img src='/assets/icons/useful/confetti.png' height={34} alt='' />
                                                </div>


                                                <div>
                                                    <p className="text-small  mt-2  mt-0 text-semibold" style={{ color: 'rgb(88, 86, 214)' }}>{translate('Congratulations')}</p>
                                                    <p className="text-semibig mb-1  mt-0 text-bold" style={{ color: 'rgb(88, 86, 214)' }}>{translate('Hub Created Successfully')}</p>
                                                </div>


                                            </div>

                                            <p className="mb-3 text-small mt-2" style={{ maxWidth: 350 }}>{translate('Your hub created successfully. now you can have access to this profile using the provided information.')}</p>

                                            <div className='d-flex pt-3' style={{ borderTop: '1px solid #eee' }}>
                                                <img src={imageAddress(this.props.initData?.image, 'hub', 'thumb')} className='br-10' height={50} width={50} alt='' />
                                                <div className='mld-4 w-100'>
                                                    <div className='flexcb flex-wrap w-100'>
                                                        <p className='text-bold text-semibig mb-1'>{this.props.initData?.name}</p>
                                                        <div className='flexc mld-2  mb-0'>
                                                            {/* <div className='br-20 px-2 py-1 text-smaller' style={{ backgroundColor: '#eee', }}>
                                                            <p className=' text-semibold'>{checkTranslation(this.props.initData?.category)}</p>
                                                        </div> */}


                                                        </div>
                                                    </div>

                                                    <p className=' text-small text-semibold'>{translate('Username')}: @{this.props.initData?.username}</p>


                                                    {/* <p className=' text-smaller text-semibold opacity-5'>{siteConfig.rootDomain}{this.props.initData?.username}</p> */}

                                                    {/* {this.props.initData?.description && (
                                                    <p className=' text-smaller mt-1'>{this.props.initData?.description}</p>
                                                )} */}

                                                </div>
                                            </div>

                                            {!this.props.initData.pendingLicense?.needsAction && (

                                                <div className='mt-2 flexc mb-2 ' style={{margin:'0px 60px'}}>
                                                    <ButtonAnimated
                                                        iconwidth='24px'
                                                        onClick={() => this.props.visitHub()}
                                                        isLoading={false}
                                                        title={checkTranslation("Visit your hub")}
                                                        // width={'100%'}
                                                        icon={'/assets/icons/angle-right-white2.svg'}
                                                        textColor={'#fff'}
                                                        invert={false}
                                                        bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                                    />
                                                </div>

                                            )}
                                            {/* <button onClick={() => this.props.visitHub()} className='px-1 py-1  flexcc' style={{ background: 'linear-gradient(to right, #6764FE, #8C64FE)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Proceed for payment")}</p>
                                                <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 10 }}>
                                                    <img className='invert' src='/assets/icons/useful/eye.svg' height={18} />
                                                </div>
                                            </button> */}
                                        </div>


                                        {!this.props.initData.pendingLicense?.needsAction && (
                                            <div className='mt-4  br-8 p-3 ' style={{ boxShadow: '0px 0px 20px #10101020', backgroundColor: '#fff' }}>

                                                <div className='flexcb'>
                                                    <p className='text-bold text-semibig mb-1'>{translate("License information")}</p>

                                                    <div className='flexc mb-1'>
                                                        <div className='br-20 px-2 py-1 text-small flexc' style={{ backgroundColor: 'rgb(251,240,207)', }}>
                                                            <div className='br-8 p-1 mrd-2 flexcc' style={{ color: 'rgb(1,47,158)' }}>
                                                                <img src='/assets/icons/applets/general/diamond-award.png' height={20} alt='' />
                                                            </div>
                                                            <div className='prd-4'>
                                                                <p className='font-size-14 main-c2 weight-600 ' style={{ color: 'rgb(210,140,10)' }}>{translate('Starter plan')}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='   mb-1'>


                                                    <p className='text-smaller mt-2'>{translate("Your hub is now under the FREE version of Yonnect. It may have some limitations. You can upgrade your plan later, in your hub's settings, account info section.")}</p>

                                                </div>
                                            </div>
                                        )}
                                        {/* <h1 className="text-big mt-0">{this.props.language == 'fa' ? translate('Hub') + ' ' + this.props.initData.name : this.props.initData.name + ' ' + translate(' Hub')}</h1> */}


                                        {/* <div className='flexc'>
                                            <button onClick={() => this.props.visitHub()} className='px-1 py-1  flexcc' style={{ background: 'linear-gradient(to right, #6764FE, #8C64FE)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("View Hub")}</p>
                                                <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 10 }}>
                                                    <img className='invert' src='/assets/icons/useful/eye.svg' height={18} />
                                                </div>
                                            </button>
                                        </div> */}




                                    </div>
                                </div>

                            </div>
                        </div>
                    </Responsive>


                    <Responsive width={this.props.width} media={{ xs: "12", sm: '12', md: '6', lg: "6", xl: "6" }}>
                        <div className='px-3 mt-4'>
                            <div className='  br-8 p-3 flexc flex-column w-100 pb-4' style={{ boxShadow: '0px 0px 20px #10101020', backgroundColor: '#fff' }}>

                                <div className='w-100 br-20 flexcc py-2 px-2' style={{ border: '0px solid #f0f0f0' }}>
                                    <QRCode onClick={() => this.props.visitHub()} quietZone={0} value={siteConfig.rootDomain + this.props.initData.username} size="120" title={siteConfig.rootDomain + this.props.initData.username} logoImage={'/logo.svg'} removeQrCodeBehindLogo={true} logoWidth={20} qrStyle={'dots'} eyeRadius={[[10, 10, 0, 10], [10, 10, 10, 0], [10, 0, 10, 10],]} eyeColor={'#303030'} enableCORS={true} ecLevel="Q" />
                                </div>
                                <div className='flexc mt-2 w-100'>
                                    <div className=' mb-2 flexcc w-100 br-20' style={{ backgroundColor: '', border: '0px solid #eee' }}>
                                        <button ><p className=" text-small text-center text-semibold" style={{ color: '' }}>{siteConfig.rootDomain}{this.props.initData.username}</p></button>
                                        {/* <img className='mld-4' src={'/assets/icons/useful/duplicate.svg'} width="20px" style={{ opacity: 0.3 }} /> */}
                                    </div>
                                </div>

                                <div className='flexcc w-100 mt-1'>

                                    <div className='flexc'>
                                        <div className="flexc mrd-2">
                                            <ButtonAnimated
                                                iconwidth='24px'
                                                onClick={() => { this.handleCopy(siteConfig.rootDomain + this.props.initData.username) }}
                                                title={translate('Copy link')}
                                                textColor={'#999'}
                                                bg={'#eee'}
                                            />
                                        </div>
                                        <button className='br-100 flexcc' style={{ position: 'relative', backgroundColor: '#eee', width: '34px', height: '34px' }} onMouseOver={() => this.setState({ showYonnect: true })} onMouseLeave={() => this.setState({ showYonnect: false })} onClick={() => { this.setState({ showYonnect: false }) }}>
                                            <img src='/assets/icons/portals/folder2.svg' width={24} height={24} />
                                            {this.state.showYonnect &&
                                                this.info('Yonnect messenger')
                                            }
                                        </button>
                                        <button className='br-100 flexcc mld-2' style={{ position: 'relative', backgroundColor: '#eee', width: '34px', height: '34px' }} onMouseOver={() => this.setState({ showQRCode: true })} onMouseLeave={() => this.setState({ showQRCode: false })} onClick={() => { this.setState({ showQRCode: false }) }}>
                                            <img src='/assets/icons/applets/drive/qr-code.svg' width={24} height={24} />

                                        </button>
                                    </div>


                                    <button className='br-100 flexcc  p-1 mx-1 flexcc' style={{ backgroundColor: '#eee', width: '34px', height: '34px' }}>
                                        <img className='' src='/assets/icons/useful/share.svg' height={18} alt='' />
                                    </button>

                                </div>

                                <p className='text-smaller mt-3'>Now your hub is part of Yonnect's community. In the next step you can create your desirable applets and enjoy using Yonnect. For more information you can use the following links:</p>


                            </div>


                            <div className='  br-8 p-3 flexc flex-column w-100 pb-4 mt-4' style={{ boxShadow: '0px 0px 20px #10101020', backgroundColor: '#fff' }}>
                                <div className='d-flex flex-column mt-2 w-100'>

                                    <p className='text-bold text-semibig mb-3'>{translate("Learn more about Yonnect")}</p>


                                    <button className='w-100 text-start'>
                                        <p className='text-link text-small'>How to start using a hub?</p>
                                    </button>

                                    <button onClick={() => { }} className='w-100 text-start mt-1'>
                                        <p className='text-link text-small'>{translate("What is an applet?")}</p>
                                    </button>

                                    <button onClick={() => { }} className='w-100 text-start mt-1'>
                                        <p className='text-link text-small'>{translate("How to create an applet?")}</p>
                                    </button>

                                    <button onClick={() => { }} className='w-100 text-start mt-1'>
                                        <p className='text-link text-small'>{translate("Permissions and access in Yonnect")}</p>
                                    </button>

                                    <button onClick={() => { }} className='w-100 text-start mt-1'>
                                        <p className='text-link text-small'>{translate("What are groups in Yonnect?")}</p>
                                    </button>

                                    <button onClick={() => { }} className='w-100 text-start mt-1'>
                                        <p className='text-link text-small'>{translate("Yonnect academy")}</p>
                                    </button>


                                </div>
                            </div>
                        </div>

                    </Responsive>

                    {/* <Responsive width={this.props.width} height="100%" media={{ xs: "none", sm: '4', md: '4', lg: "6", xl: "6" }}>

                        <div className="text-center" style={{ minHeight: '100vh', position: 'relative', top: 0, padding: '100px 30px 20px 30px', backgroundPosition: 'center', backgroundSize: 'cover' }}>


                            <div className='flexc flex-column' style={{ position: 'sticky', top: 70 }}>
                                <img className=" mb-2" src={'/assets/icons/portals/Asset 2.svg'} width={'90px'} />
                                <p className="text-big text-bold">{translate("Create Hub").toUpperCase()}</p>
                                <p className=" text-smaller" style={{ maxWidth: '300px' }} >{translate("Description about new hub and the terms of use will be shown here")}</p>
                            </div>
                        </div>

                    </Responsive> */}


                </div>
            </div>

        )
    }
}


// export default withRouter(CHSuccess)

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CHSuccess);
